import React from 'react';
import { observer } from 'mobx-react-lite';
import { messageModel } from '../MessageModel';
import { ChatMessageList } from './ChatMessageList';
import { ChatInputBar } from './ChatInputBar';
import { getPeerUserId } from '../MessageConfig';
import { CachedImage } from '../../components/CachedImage';

export const ChatDetailPanel: React.FC = observer(() => {
  const room = messageModel.selectedRoom;

  if (!room) {
    return (
      <div className="message-detail-empty">
        <div>选择一个会话开始聊天</div>
      </div>
    );
  }

  const peerId = room.isGroup
    ? undefined
    : getPeerUserId(room, messageModel.getVisibleMessages(room.id));
  const peerInfo = peerId ? messageModel.userInfoCache.get(peerId) : undefined;
  const title = room.isGroup
    ? room.name || '群聊'
    : peerInfo?.name || room.name || '会话';
  const avatar = room.isGroup ? room.avatar : peerInfo?.avatar || room.avatar;

  return (
    <div className="message-detail">
      <div className="message-detail-header">
        {avatar ? (
          <CachedImage url={avatar} style={{ width: 32, height: 32, borderRadius: 4 }} />
        ) : (
          <div className="message-room-avatar-placeholder small" />
        )}
        <span className="message-detail-title">{title}</span>
      </div>
      <div className="message-detail-body">
        <ChatMessageList roomId={room.id} />
        <div className="message-composer-shell">
          <ChatInputBar roomId={room.id} />
        </div>
      </div>
    </div>
  );
});
